module.exports = __webpack_public_path__ + "img/km.dc8805c0.svg";